import { useQuery } from '@tanstack/react-query';

import { claudeApi } from '../lib/api';
import { useAuthStore } from '../stores/authStore';

/**
 * Poll the health of the Claude credential.
 *
 * Admin-only: the endpoint returns 403 for everyone else, so the query is
 * disabled rather than left to fail on a loop.
 *
 * `staleTime: 0` is required — the global default in App.tsx is 5 minutes,
 * which would otherwise serve a cached status and defeat the polling.
 */
export const useClaudeStatus = () => {
  const user = useAuthStore((state) => state.user);
  const isAdmin = user?.role === 'admin';

  return useQuery({
    queryKey: ['claude-status'],
    queryFn: () => claudeApi.getStatus(),
    enabled: isAdmin,
    staleTime: 0,
    refetchInterval: 60_000,
    // A momentary blip shouldn't flash a scary banner.
    retry: 1,
  });
};
